import store from '../store';
import Constants from '../config/constants';
import {serviceGetIncentiveReportProduct} from "../services/IncentiveReport.service";

export const FETCH_INIT = 'FETCH_INIT_PRODUCT_REPORT';
export const FETCHED = 'FETCHED_PRODUCT_REPORT';
export const FETCHED_FAIL = 'FETCHED_FAIL_PRODUCT_REPORT';
export const FETCHED_FILTER = 'FETCHED_FILTER_PRODUCT_REPORT';
export const FETCH_NEXT = 'FETCH_NEXT_PRODUCT_REPORT';
export const FILTER = 'FILTER_PRODUCT_REPORT'; 
export const RESET_FILTER = 'RESET_FILTER_PRODUCT_REPORT';
export const SET_SORTING = 'SET_SORTING_PRODUCT_REPORT';
export const SET_FILTER = 'SET_FILTER_PRODUCT_REPORT';
export const SET_PAGE = 'SET_PAGE_PRODUCT_REPORT';
export const CHANGE_PAGE = 'CHANGE_PAGE_PRODUCT_REPORT';
export const CHANGE_STATUS= 'CHANGE_STATE_PRODUCT_REPORT';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_PRODUCT_REPORT';
export const CREATE_DATA = 'CREATE_PRODUCT_REPORT';
export const UPDATE_DATA = 'UPDATE_PRODUCT_REPORT';
export const DELETE_ITEM = 'DELETE_PRODUCT_REPORT';


export function actionFetchIncentiveReportProduct(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetIncentiveReportProduct({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageIncentiveReportProduct(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}


export function actionFilterIncentiveReportProduct(value) {
    const request = null;
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusIncentiveReportProduct(id, status) {
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterIncentiveReportProduct() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageIncentiveReportProduct(page, extraPayload = {}) {
    const stateData = store.getState().product_report;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data; 
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchIncentiveReportProduct(serverPage + 1, sortingData, {query, query_data: queryData,   ...extraPayload}));
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
